import React from 'react';
import { Link } from 'react-router-dom';
import EmailsStats from './emails/EmailsStats';
import SmsStats from './sms/SmsStats';

// Landing page: email and SMS stats side by side, plus shortcuts to send.
function Overview() {
  return (
    <div style={{ paddingLeft: 25, paddingRight: 25, width: '100%' }} className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Overview</h4>
        <div className="d-flex gap-2">
          <Link to="/new-email" className="btn btn-primary d-flex align-items-center">
            <i className="bi bi-pencil-square me-2"></i>
            New Email
          </Link>
          <Link to="/new-sms" className="btn btn-primary d-flex align-items-center">
            <i className="bi bi-pencil-square me-2"></i>
            New SMS
          </Link>
        </div>
      </div>

      <h6 className="text-secondary mb-3">Email</h6>
      <EmailsStats />

      <h6 className="text-secondary mb-3">SMS</h6>
      <SmsStats />
    </div>
  );
}

export default Overview;
